import React from 'react';

export const LocationLogo = ({ width = '18', height = '18', fill = 'var(--icon-color-base)' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1263_2061)">
        <path
          d="M16.5 7.5V6.91312C16.5 5.4584 16.5 4.73105 16.0606 4.27913C15.6213 3.82721 14.9142 3.82721 13.5 3.82721H11.941C11.253 3.82721 11.2473 3.82587 10.6286 3.51626L8.12992 2.26585C7.08663 1.74378 6.56499 1.48274 6.00928 1.50088C5.45357 1.51903 4.94908 1.81356 3.94009 2.40263L3.01918 2.94028C2.27804 3.37297 1.90747 3.58932 1.70373 3.94923C1.5 4.30915 1.5 4.74745 1.5 5.62405V11.7868C1.5 12.9386 1.5 13.5145 1.75669 13.835C1.92751 14.0482 2.16687 14.1916 2.4315 14.2392C2.82919 14.3106 3.31611 14.0264 4.2899 13.4578C4.95117 13.0718 5.58758 12.6708 6.37865 12.7796C7.04152 12.8706 7.6575 13.2889 8.25 13.5854"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M6 1.5V12.75" stroke={fill} stroke-width="1.5" stroke-linejoin="round" />
        <path d="M11.25 3.75V7.125" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M13.7312 16.2626C13.5686 16.4149 13.3513 16.5 13.1251 16.5C12.8989 16.5 12.6815 16.4149 12.5189 16.2626C11.0297 14.8597 9.03412 13.2926 10.0073 11.0174C10.5335 9.7872 11.7967 9 13.1251 9C14.4535 9 15.7166 9.7872 16.2428 11.0174C17.2148 13.2897 15.2241 14.8645 13.7312 16.2626Z"
          stroke={fill}
          stroke-width="1.5"
        />
        <path
          d="M13.125 12.375H13.1318"
          stroke={fill}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1263_2061">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
